import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const client = axios.create({ baseURL: BASE });

client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("haas_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("haas_admin_token");
      window.dispatchEvent(new Event("haas-unauthorized"));
    }
    return Promise.reject(err);
  }
);

// Prefix backend origin only for server-served uploads (/api/...). Local /mosaic assets stay relative.
export const mediaUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
};

export const api = {
  // public
  categories: () => client.get("/categories").then((r) => r.data),
  products: (category) => client.get("/products", { params: category ? { category } : {} }).then((r) => r.data),
  product: (slug) => client.get(`/products/${slug}`).then((r) => r.data),
  projects: () => client.get("/projects").then((r) => r.data),
  sendContact: (data) => client.post("/contact", data).then((r) => r.data),
  // auth
  login: (username, password) => client.post("/admin/login", { username, password }).then((r) => r.data),
  me: () => client.get("/admin/me").then((r) => r.data),
  // admin CRUD
  createCategory: (d) => client.post("/categories", d).then((r) => r.data),
  updateCategory: (id, d) => client.put(`/categories/${id}`, d).then((r) => r.data),
  deleteCategory: (id) => client.delete(`/categories/${id}`).then((r) => r.data),
  createProduct: (d) => client.post("/products", d).then((r) => r.data),
  updateProduct: (id, d) => client.put(`/products/${id}`, d).then((r) => r.data),
  deleteProduct: (id) => client.delete(`/products/${id}`).then((r) => r.data),
  createProject: (d) => client.post("/projects", d).then((r) => r.data),
  updateProject: (id, d) => client.put(`/projects/${id}`, d).then((r) => r.data),
  deleteProject: (id) => client.delete(`/projects/${id}`).then((r) => r.data),
  messages: () => client.get("/contact").then((r) => r.data),
  analytics: (days = 30) => client.get("/admin/analytics", { params: { days } }).then((r) => r.data),
  track: (payload) => client.post("/track", payload).then((r) => r.data),
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
};
